export default __webpack_public_path__ + "./image/9c16b39b2eee7436f2cdd045ae97fe14.png";